import React from 'react';
import { createPortal } from 'react-dom';
import { compose, lifecycle, componentFromStreamWithConfig } from 'recompose';

const container = (window && window.parent.document) || document;
const scrPortalClassName = 'scr-portal';

const CreatePortal = props => {
  return createPortal(
    [<div className={scrPortalClassName}>{props.children}</div>],
    container.body
  );
};

const removeSCRPortal = () => {
  let scrPortalContainers = container.getElementsByClassName(
    scrPortalClassName
  );
  while (scrPortalContainers[0]) {
    scrPortalContainers[0].remove();
  }
};

const PortalWithState = compose(
  lifecycle({
    componentDidMount() {
      window.parent.addEventListener('hashchange', removeSCRPortal, false);
    },
    componentWillUnmount() {
      window.parent.removeEventListener('hashchange', removeSCRPortal);
    }
  })
);

export const Portal = PortalWithState(CreatePortal);
